import React from "react";
import { Globe, Printer, Puzzle, TabletSmartphone } from "lucide-react";
import { Translate } from "components/common/Translate/Translate";
import {
    ISectionUseCase,
    SectionUseCaseScaffold,
} from "components/features/CropImage/CropSectionUseCaseScaffold";

const bestUseList: ISectionUseCase[] = [
    {
        title: "Customizable-Cropping-heading",
        subTitle: "Customizable-Cropping-sub-heading",
        icon: <Globe strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "Secure-and-Reliable-Cropping-heading",
        subTitle: "Secure-and-Reliable-Cropping-sub-heading",
        icon: <Puzzle />,
    },
    {
        title: "Precise-Cropping-heading",
        subTitle: "Precise-Cropping-sub-heading",
        icon: <TabletSmartphone />,
    },
    {
        title: "Versatile-Format-Support-heading",
        subTitle: "Versatile-Format-Support-sub-heading",
        icon: <Printer />,
    },
];
const CropImageFreeContent = () => {
    return (
        <SectionUseCaseScaffold
            title={<Translate keyName="Crop-Images-Free-title" />}
            useCases={bestUseList}
        />
    );
};

export default CropImageFreeContent;
